module.exports = __webpack_public_path__ + "img/dynamic-26 - 副本.10b415d2.png";